import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AlertProvider } from './context/Alert.context';
import { AuthProvider } from './context/Auth.context';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import { router } from './routes/routes';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#53c855',
    },
  },
});

const rootElement = document.getElementById('root') as HTMLElement;

const RootApp: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <AlertProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </AlertProvider>
    </ThemeProvider>
  );
};

ReactDOM.createRoot(rootElement).render(<RootApp />);
